"use client";

import PrivateProfileDrawers from "./PrivateProfileDrawers";
import PrivateSettingsDrawers from "./PrivateSettingsDrawers";
import PrivateSourceDrawers from "./PrivateSourceDrawers";
import PrivateUtilityDrawers from "./PrivateUtilityDrawers";

export default function PrivateGlobalDrawers() {
  return (
    <>
      <PrivateSourceDrawers />
      <PrivateProfileDrawers />
      <PrivateSettingsDrawers />
      <PrivateUtilityDrawers />
    </>
  );
}
